import React from 'react'
import { isNil } from 'ramda'

export default class ImageWithFallback extends React.Component {
  constructor() {
    super()
    this.state = {}
    this.fallback = () => {
      if (this.props.fallbackSrc) {
        this.setState({ failed: true })
      }
    }
  }

  render() {
    const { className, src, alt } = this.props
    if (isNil(src) || this.state.failed) {
      return (
        <img alt={alt} src={this.props.fallbackSrc} className={className} />
      )
    } else {
      return (
        <img
          alt={alt}
          src={this.props.src}
          onError={this.fallback}
          className={className}
        />
      )
    }
  }
}
